import { DependencyList, useEffect } from 'react';

/**
 * This hook allows applying an effect to a component after only the first render.
 *
 * @param func
 */
export const useAsyncEffect = (func: () => Promise<void>, deps: DependencyList = []) => {
  useEffect(() => void func(), deps);
};
